<template>
  <div :class="'client-story ' + clientNameNoSpace">
    <h2 class="client-story__project-name" v-html="formattedProjectName"></h2>
    
    <div class="client-story__content">
      <!--
      <h3 class="client-story__client-name">{{ clientName }}</h3>
      -->
      <div class="client-story__problem">
        <h3>
          <img 
            :src="getIconSrc('lock', 'orange')" 
            alt="lock icon"
            class="line-icon"
            width="30"
            height="30"
          />
          Problem
         
        </h3>
        <p>{{ problem }}</p>
      </div>
      <div class="client-story__solution">
        <h3>
          <img 
            :src="getIconSrc('key', 'blue-bright')" 
            alt="key icon"
            class="line-icon"
            width="30"
            height="30"
          />
          <span class="client-story__solution-title">Solution</span>
          
        </h3>
        <p>{{ solution }}</p>
      </div>
    </div>
    <div :class="'client-story__logo ' + clientNameNoSpace">
      <img 
        :src="logoPath" 
        :alt="clientName"
        width="200"
        height="60"
      />
    </div>
    <!-- Removed for launch 
    <div v-if="quote && quote.length" class="client-story__quotes">
      <blockquote v-for="(quoteText, index) in quote" :key="index">
        {{ quoteText }}
      </blockquote>
    </div>
    -->
  </div>
</template>

<script>
export default {
  name: 'ClientStory',
  props: {
    logo: {
      type: String,
      required: true
    },
    clientName: {
      type: String,
      required: true
    },
    projectName: {
      type: String,
      required: true
    },
    problem: {
      type: String,
      required: true
    },
    solution: {
      type: String,
      required: true
    },
    quote: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    clientNameNoSpace() {
      return this.clientName.replace(/\s+/g, '');
    },
    logoPath() {
      try {
        // Remove the @/ prefix if it exists
        const cleanPath = this.logo.replace('@/', '');
        // Use relative path like other components
        return new URL(`../assets/images/client-logos/${cleanPath}`, import.meta.url).href;
      } catch (e) {
        console.warn(`Logo not found for ${this.logo}`);
        return '';
      }
    },
    formattedProjectName() {
      return this.projectName.replace(
        /\*\*(.*?)\*\*/g, 
        (_, text) => `<span class="highlight">${text}</span>`
      );
    }
  },
  methods: {
    getIconSrc(icon, color) {
      return `/assets/images/icon_${icon}_line-${color}.svg`;
    }
  }
}
</script>

<style lang="scss" scoped>

.client-story__logo {
&.GenderandDisastersCRC {
  background-color: rgb(44, 62, 80)
}

}


//client story grid
.client-story {
  background-color: $gray-medium;
  &.FutureFoodSystemsCRC {
    background-color: $blue-dark;
  }
  padding: $spacing-lg;
  
  border-radius: $border-radius;
  box-shadow: $shadow-sm;

  &__logo {
    margin-bottom: $spacing-md;
    grid-area: logo;
    text-align: right;
    img {
      max-height: 107px;
      width: auto;
      margin-left: auto;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: $spacing-md;
    grid-area: content;
    flex-wrap: wrap;
    flex-direction: row;
    margin: $spacing-md 0;
    > div {
      flex: 1 1 49%;
      background-color: $color-white;
      padding: $spacing-md;
      border-radius: $border-radius;
      p {
        text-wrap: pretty;
    }
  }
  }

  &__project-name {
    font-size: $font-size-h2;
    color: $blue-dark;
    @include museo-700;
    //font-weight: $font-weight-bold;
    margin: 0;
    grid-area: project-name;
    flex: 2 2 100%;
    min-width: 100%;

    :deep(.highlight) {
      color: $color-primary;
    }
  }
  &.FutureFoodSystemsCRC {
    .client-story__project-name {
      color: $color-white;
    }
  }

  &__client-name {
    font-size: $font-size-h4;
    color: $color-text-light;
    margin: 0;
  }

  &__problem,
  &__solution {
    h3 {
      border-bottom: 3px solid $color-primary;
      padding-bottom: $spacing-xs;
      margin-bottom: $spacing-md;
      display: flex;
      align-items: center;
      //justify-content: space-between;
      gap: $spacing-sm;
      //margin-bottom: $spacing-xs;
      span {
        @include proxima-bold;
      }

      .line-icon {
        width:1.5rem;
        height: 1.5rem;
        object-fit: contain;
        
      }
    }

    p {
      margin: 0;
      line-height: $line-height-base;
    }
  }
  &__problem {
    h3 {
      color: $orange;
      border-bottom-color: $orange;
    }
  }
  &__solution {
    h3 {
      color: $blue-bright;
    }
  }

  &__quotes {
    margin-top: $spacing-md;
    grid-area: quotes;
    blockquote {
      font-style: italic;
      padding: $spacing-sm;
      border-left: 3px solid $color-primary;
      margin: $spacing-sm 0;
    }
  }
}
</style>
